<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="checks">
    <div class="check" *ngFor="let check of checks">
      <app-svg src="/assets/icons/check-outline.svg"></app-svg>
      <span>{{ check.text }}</span>
    </div>
  </div>
  <div class="empty" *ngIf="checks && !checks.length">EMPTY CHECK LIST</div>
</app-block-wrapper>
